import { HomePageFeature } from 'features/PageTypes/HomePage/HomePageFeature';

export const SegmentPageFeature = HomePageFeature;
